import { Navigate } from 'react-router-dom';

import { FOOTBALL_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { Wheel } from '@sorare/marketplace/src/components/Wheel';

export const FootballMarketWheel = () => {
  const {
    flags: {
      marketDailyWheelBySportAndRarity = {
        baseball: { limited: false, common: false },
        football: { limited: false, common: false },
        nba: { limited: false, common: false },
      },
    },
  } = useFeatureFlags();

  if (!marketDailyWheelBySportAndRarity?.football?.limited) {
    return <Navigate to={FOOTBALL_MARKET} replace />;
  }

  return <Wheel />;
};

export default FootballMarketWheel;
